// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"5ac97831","583":"c85bffb8","845":"2e3174ea"}[chunkId] + ".chunk.js";
};